// Recently viewed products in the mobile drawer
class NavRecentlyViewed extends HTMLElement {
  static storageKey = 'alc:recently-viewed';

  static read() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey) || '[]');
    } catch (e) {
      return [];
    }
  }

  async connectedCallback() {
    if (window.matchMedia('(max-width: 1240px)').matches) await this.populate();
    this.record(this.dataset.productHandle);
  }

  async populate() {
    const { productHandle, limit } = this.dataset;
    const handles = NavRecentlyViewed.read()
      .filter((handle) => handle !== productHandle)
      .slice(0, Number(limit));

    const docs = await Promise.all(handles.map((handle) =>
      fetch(`/products/${handle}?section_id=nav-recently-viewed`)
        .then((response) => (response.ok ? response.text() : ''))
        .then((html) => new DOMParser().parseFromString(html, 'text/html'))
        .catch(() => null)));

    const list = this.querySelector('.nav-recently-viewed__list');
    docs.forEach((doc) => {
      const slide = doc && doc.querySelector('template[data-slide]');
      if (slide) list.append(slide.content.cloneNode(true));
    });

    this.hidden = !list.children.length;
  }

  record(handle) {
    const max = Number(this.dataset.max);
    if (!handle || !max) return;
    const history = [handle, ...NavRecentlyViewed.read().filter((h) => h !== handle)];
    try {
      localStorage.setItem(NavRecentlyViewed.storageKey, JSON.stringify(history.slice(0, max)));
    } catch (e) { /* storage unavailable */ }
  }
}

customElements.define('nav-recently-viewed', NavRecentlyViewed);
